<app-filter-table (resetPaginator)="resetPaginator($event)" #filter></app-filter-table>
<app-data-table [catalogs]="filter.catalogs"></app-data-table>
<app-impaired-pagination (paginatorChanged)="filter.paginatorChanged($event)" #paginator [allCount]="(allCatalogCount$ | async) ?? 0" [currentCount]="filter.catalogCount" ></app-impaired-pagination>
